// import { env } from './.env';

export const environment = {
  production: true,
  // version: env.npm_package_version,
  serverUrl: 'https://stagingapi.tallify.in',
  // serverUrl: 'http://localhost:8080',
  appName: 'Tallify-erp-sync'
};
